import React, { useState, useEffect } from 'react';
import config from "../../Config";
import axios from "axios";


function BanksDropDown(props) {

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [ListofRecords, setListofRecords] = useState([]);

    useEffect(() => {

        const apiData = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            PageNo: 1,
            PageSize: 100
        };

        var api_config = {
            method: 'post',
            url: config.base_url + 'Setup/GetAllBanks',
            headers: {
                'Content-Type': 'application/json'
            },
            data: apiData
        };

        axios(api_config)
            .then(function (response) {
                ////console.log(response.data);
                setListofRecords(response.data.ListofRecords || []);
            })
            .catch(function (error) {
                //console.log(error);
            });

    }, []);



    return (
        ListofRecords.map((item, index) => {
            return (
                <option value={item.ID} key={index}>{item.Bank_Name}</option>
            )
        })
    );
}

export default BanksDropDown;